import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import { Recommendation } from '../../data-access/models/card-to-card-recommendation-response';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { OnHoldDirective } from '@client-monorepo/common/utilities';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'c2c-applet-recommendation-item',
  standalone: true,
  imports: [CommonModule, ApiImageModule, PipesModule, OnHoldDirective, NgxButtonComponent],
  templateUrl: './recommendation-item.component.html',
  styleUrls: ['./recommendation-item.component.scss'],
})
export class RecommendationItemComponent implements OnInit {
  @Output()
  moreOption = new EventEmitter();

  @Output()
  clickCard = new EventEmitter();

  @Input()
  spinner = false;

  amount = '';

  icon = '';

  @Input()
  item!: Recommendation;

  @Input()
  showMoreAction = true;

  @Input()
  clickable = true;

  ngOnInit() {
    this.item?.info?.forEach((i) => {
      if (i.label === 'amount') {
        this.amount = i.value;
      }

      if (i.label === 'iconId') {
        this.icon = i.value;
      }
    });
  }

  more() {
    if (!this.showMoreAction) {
      return;
    }
    this.moreOption.emit();
  }

  handleClick(event: Event) {
    event.stopPropagation();
    this.clickCard.emit();
  }
}
